import React from 'react';
import GpyComponent from './GpyComponent'
import {_GPY} from '../../../env.js'

class GpyKeybindingButton extends GpyComponent {

  constructor(props) {
	   super(props);
     this.state = {
            conf : {autoexpirytime : props.autoexpirytime===undefined?0: parseInt(props.autoexpirytime), onlyWarn: (props.warnOnly !== undefined &&  ( props.warnOnly === "true" ||  props.warnOnly === true )?true:false) , keyCode : props.keyCode},
            captureCodeMode:false,
            keyCodeEditMode:false,
            editAutoexpirytimeMode:false,
            dkeyCode: " DEF",
          //  cssClass: (typeof (this.props.className) === "function")?this.props.className():this.props.className,
		 };
     this.state.dkeyCode = _GPY.getDisplayKeyCode(this.state.conf);
	  }



    componentDidMount() {
      console.log(this.props.title,this.props.scoreboard);
      if(this.props.scoreboard !== undefined ){
         this.props.scoreboard.registerButton( this.getStateName() , this );
      };
      if(this.props.onCreate!==undefined) {
         this.props.onCreate(this);
      }
    }

    disableEditMode(){
      this.setState({editAutoexpirytimeMode:false,keyCodeEditMode:false});
    }

    toggleKeyCodeEditMode(forceValue){
      if(forceValue!==undefined) {
        this.setState({editAutoexpirytimeMode:false,captureCodeMode:false,keyCodeEditMode:forceValue});
      } else {
        this.setState({editAutoexpirytimeMode:false,captureCodeMode:false,keyCodeEditMode:!this.state.keyCodeEditMode});
      }
    }

    toggleAutoexpirytimeEditMode(forceValue){
      if(forceValue!==undefined) {
        this.setState({keyCodeEditMode:false,editAutoexpirytimeMode:forceValue});
      } else {
        this.setState({keyCodeEditMode:false,editAutoexpirytimeMode:!this.state.editAutoexpirytimeMode});
      }
    }

    captureKeyCode(){
       this.setState({captureCodeMode:true});
    }

    getConfig() {
      return this.state.conf;
    }

    setConfig(c) {
      var dkey = _GPY.getDisplayKeyCode(c);
      this.setState( {conf:c , dkeyCode:dkey } );
    }

    onKeyDown(e) {
      if(this.state.captureCodeMode){
        if(e.key === "Backspace"){
          var conf = this.state.conf;
          conf.keyCode = undefined;
          this.setState({conf:conf,captureCodeMode:false,dkeyCode:_GPY.getDisplayKeyCode(conf)});
          e.preventDefault();
          return;
        } else if(e.key !== "CapsLock" && e.key !== "Shift" && e.key !== "Control"  && !e.key.startsWith("Alt") && e.key !== "Meta"  && e.key !== "Enter"  && e.key !== "Escape") {
          var conf = this.state.conf;
          conf.keyCode = e.key;
          this.setState({conf:conf,captureCodeMode:false,dkeyCode:_GPY.getDisplayKeyCode(conf)});
          e.preventDefault();
          return;
        }
      }
      if(this.state.conf.keyCode !== undefined && this.state.conf.keyCode === e.key) {
          this.onButton();
          e.preventDefault();
          return;
      }
    }

    getStateName(){
      if(typeof (this.props.stateName)  === "function") {
        return this.props.stateName();
      }
      else return this.props.stateName;
    }

    onButton() {
      if(this.props.disabled) return;

        if(this.props.onClick!==undefined) {
          if(typeof (this.props.className)  === "function") {
            this.setState({cssClass : this.props.className() + " btn-danger"});
          } else {
            this.setState({cssClass : this.props.className + " btn-danger"});
          }
          this.props.onClick();

          clearInterval(this.interval);
          this.interval = setInterval(() => {
             clearInterval(this.interval);
             this.setState({cssClass : (typeof (this.props.className) === "function")?this.props.className():this.props.className});
          }, (250));
        }
    }

	 render() {
     let cssClass = (typeof (this.props.className) === "function")?this.props.className():this.props.className;

      if(this.state.keyCodeEditMode) {
            return (
              <button type="button" onClick={()=>{this.captureKeyCode()}} className={cssClass +" "+(this.state.captureCodeMode?"btn-danger":"btn-outline-secondary buttonBG")}>
                {this.state.captureCodeMode?
                  <>press any key <span className="glyphicon glyphicon-hourglass"/></>
                  :
                  <>
                  {this.props.title}{this.state.dkeyCode} <span className="glyphicon glyphicon-edit"/>
                  </>
                }
              </button>
            )
        } else {
            return (
              <button disabled={this.props.disabled!==undefined?this.props.disabled:false} type="button" onClick={()=>{this.onButton()}} className={cssClass}>{this.props.title}{this.state.dkeyCode}</button>
            )
        }
    }
}
export default GpyKeybindingButton;
